module.exports = __webpack_public_path__ + "img/13-otp.9a35d026.jpg";